import { render, staticRenderFns } from "./BfAlert.vue?vue&type=template&id=61612aea&"
import script from "./BfAlert.vue?vue&type=script&lang=js&"
export * from "./BfAlert.vue?vue&type=script&lang=js&"
import style0 from "./BfAlert.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports